import React, { Component } from 'react'
import {List, Toast} from 'antd-mobile'
import { ORG_CODE, FARM_ORG } from '../../cache'
import Day from './components/day'
import LinkText from './components/link'
import Table from '../../components/Table';
import send from '../../utils/send';
import EmptyReport from "../../components/EmptyReport";
class Report15 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDay: false,
      day: 7,
      columns: [
        {
          id: 'farm_name_loc',
          title: '序号',
          align: 'left',
          fixed: true,
          render (data, index) {
            return index + 1
          }
        },
        {
          id: 'swine_track',
          title: '猪只代码',
          align: 'left',
          fixed: true
        },
        {
          id: 'litno1',
          title: '胎次'
        },
        {
          id: 'last_activity_type',
          title: '上次状态'
        },
        {
          id: 'last_activity_date',
          title: '上次状态日期'
        },
        {
          id: 'activity_type',
          title: '目前状态'
        },
        {
          id: 'activity_date',
          title: '目前状态日期'
        },
        {
          id: 'birth_date',
          title: '出生日期'
        },
        {
          id: 'date_diff',
          title: '天数'
        },
        {
          id: 'day_over_due',
          title: '逾期天数'
        },
        {
          id: 'printReportTime',
          title: '备注',
          render () {
            return ''
          }
        }
      ],
      tableData: []
    }
  }
  componentDidMount() {
    this.doSearch()
  }

  onCancel = () => {
    this.setState({
      showDay: false
    })
  };
  doSearch = () => {
    Toast.loading('请稍后', 0);
    const {day} = this.state;
    send({
      url: '/api/forward/ifarm/report15',
      method: 'POST',
      data: {
        orgCode: ORG_CODE,
        farmOrg: FARM_ORG,
        day,
        serviceType: 'M'
      }
    }).then(res => {
      Toast.hide();
      let attrs = ["farm_name_loc","swine_track","litno1","last_activity_type","last_activity_date","activity_type","activity_date","birth_date","date_diff","day_over_due","printReportTime"];
      res.data.forEach(o => {
        attrs.forEach(a => {
          if (typeof o[a] === 'undefined'){
            o[a] = ''
          }
        })
      });
      if (!(res.data instanceof Array)) {
        return
      }
      this.setState({
        tableData: res.data
      })
    })
  };
  render() {
    const {showDay, day} = this.state;
    return (
      <React.Fragment>
        <div className="oneH">
          <List  className={showDay? 'single-multi-menu-active' : ''}>
            <List.Item className={'single-multi-top-nav-bar'}
                onClick={() => {
              this.setState({showDay: !showDay})
            }}
            >
              <LinkText show={showDay}>期间长度</LinkText>

            </List.Item>
          </List>
          {
            showDay ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
              <Day
                  onCancel={() => {
              this.setState({showDay: false})
              }}
                  onConfirm={(val) => {
              this.setState({
                day: val,
                showDay: false
              }, () => {
                this.doSearch()
              })
              }}
                  value={day}
              />
            </div>: null
          }

          {showDay ? <div className="menu-mask"
              onClick={this.onMaskClick}
                     /> : null}


          {this.state.tableData.length > 0 ?
            <Table columns={this.state.columns}
                   data={this.state.tableData}
                   stripe
            />
            : <EmptyReport height={250} />}
        </div>
      </React.Fragment>
    )
  }
}

export default Report15
